jQuery(function ($) {
	//Check to see if the window is top if not then display button
	$(window).scroll(function () {
		if ($(this).scrollTop() > 250) {
			$('.backToTop').fadeIn();
		} else {
			$('.backToTop').fadeOut();
		}
	});
	//Click event to scroll to top
	$(".backToTop").click(function (event) {
		event.preventDefault();
		//calculate destination place
		var dest = 0;
		if ($('html').offset().top > $(document).height() - $(window).height()) {
			dest = $(document).height() - $(window).height();
		} else {
			dest = $('html').offset().top;
		}
		//go to destination
		$('html,body').animate({ scrollTop: dest }, 1000, 'swing');
	});
});


// WEBPACK FOOTER //
// ./scripts/old/backtotop.js